"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _UIResponsiveComponent = _interopRequireDefault(require("ecosystem-marketplace-core/components/UIResponsiveComponent"));

var MainSectionHeading = function MainSectionHeading(_ref) {
  var itemRight = _ref.itemRight,
      subheading = _ref.subheading,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["itemRight", "subheading"]);
  var wrapperClassName = 'm-bottom-4';
  var headingClassName = (0, _classnames.default)({
    'm-bottom-0': !subheading
  });

  var renderedHeading = _react.default.createElement(_H.default, (0, _extends2.default)({}, rest, {
    className: headingClassName
  }));

  if (subheading) {
    renderedHeading = _react.default.createElement(_react.Fragment, null, renderedHeading, _react.default.createElement("p", {
      className: "m-bottom-0"
    }, subheading));
  }

  if (itemRight) {
    return _react.default.createElement(_UIGrid.default, {
      className: wrapperClassName
    }, _react.default.createElement(_UIGridItem.default, {
      size: {
        sm: 12,
        md: 8
      }
    }, renderedHeading), _react.default.createElement(_UIGridItem.default, {
      className: "align-self-end",
      size: {
        sm: 12,
        md: 4
      }
    }, _react.default.createElement(_UIResponsiveComponent.default, {
      styles: {
        sm: 'margin-top: 8px',
        md: 'width: 100%; text-align: right'
      }
    }, itemRight)));
  }

  return _react.default.createElement("div", {
    className: wrapperClassName
  }, renderedHeading);
};

MainSectionHeading.propTypes = {
  itemRight: _propTypes.default.node,
  subheading: _propTypes.default.node
};
var _default = MainSectionHeading;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/layout/MainSectionHeading.js
// module id = 383
// module chunks = 209 210 211 212